var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadSpeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 9.49761e-07 7 6.11959e-07C3.136 2.74158e-07 9.49761e-07 3.136 6.11959e-07 7C2.74158e-07 10.864 3.136 14 7 14ZM4.2 7C4.396 7 4.571 7.077 4.697 7.203L6.3 8.813L6.3 3.5C6.3 3.115 6.615 2.8 7 2.8C7.385 2.8 7.7 3.115 7.7 3.5L7.7 8.813L9.303 7.203C9.429 7.077 9.604 7 9.8 7C10.185 7 10.5 7.315 10.5 7.7C10.5 7.896 10.423 8.071 10.297 8.197L7.497 10.997C7.371 11.123 7.196 11.2 7 11.2C6.804 11.2 6.629 11.123 6.503 10.997L3.703 8.197C3.577 8.071 3.5 7.896 3.5 7.7C3.5 7.315 3.815 7 4.2 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSpeedIcon);
export default __webpack_public_path__ + "static/media/download_speed_icon.4b7b77c14573dea6a90fcdb29d4807e0.svg";
export { ForwardRef as ReactComponent };